import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { CardTotalType } from "../typings";

export function useSaldo(params: any) {
  return useQuery<CardTotalType, AxiosError>(
    `/v1/dashboards/principal/total-saldo-${params.dataFim}-${params.dataInicio}-${params.updatedAt}-${params.contaBancariaId}`,
    async () => {
      const { data } = await http.get<CardTotalType>(
        "/v1/dashboards/principal/total-saldo",
        {
          params,
        }
      );

      return data;
    }
  );
}
